import { gql } from '@apollo/client';
import { GqlSeason, GqlSeasonFragment } from '../fragments/season';

export interface Input {
  id: number;
}

export interface Data {
  deleteSeason: GqlSeason;
}

export const MUTATION = gql`
  mutation DeleteSeason($id: ID!) {
    deleteSeason(id: $id) {
      id
      name
      programId
      tsDivisionId
      isArchived
    }
  }
`;
